export default __webpack_public_path__ + "static/media/favicon.19caf84d.ico";